import { render } from "./TaskList.vue?vue&type=template&id=ac07a420&scoped=true"
import script from "./TaskList.vue?vue&type=script&lang=js"
export * from "./TaskList.vue?vue&type=script&lang=js"

import "./TaskList.vue?vue&type=style&index=0&id=ac07a420&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-ac07a420"

export default script